/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OptimizationSolutionEntryRequest } from '../../models/optimization-solution-entry-request';

export interface ReceiveOptimizerOutput$Params {
  location_id: string;
  
    /**
     * request
     */
    body: OptimizationSolutionEntryRequest
}

export function receiveOptimizerOutput(http: HttpClient, rootUrl: string, params: ReceiveOptimizerOutput$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, receiveOptimizerOutput.PATH, 'post');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

receiveOptimizerOutput.PATH = '/locations/{location_id}/optimizer/results';
